export { default } from './PrivateRoute';